import React from "react";
import ToolBar from "../../../components/toolbar/ToolBar";
import url from '../../../url'
import Select from "react-select";
import axios from "axios";
import { getFDate } from "../../../util/date";
import { store } from 'react-notifications-component';
import Loading from "../../../components/loading/Loading";
import ModernAlert from "../../../components/alert/ModernAlert";
import './management-panel.css'
import grupos from '../../../data/cdcGroups.json'
import RadioOptions from "../../../components/cdc/radio-options/RadioOptions";
import { Table, Button } from "reactstrap";
import ListOrders from "../../../components/cdc/list-orders/ListOrders";



class ManagementPanel extends React.Component {
    columns = [
        "Cavalo",
        "Equipamento",
        "Motorista",
        "Carga",
        "Data Planejada",
        "Hora de Saída",
        "Previsão Chegada",
        "Data Chegada",
        "Status",
        "Pedidos",
    ]

    radios = [
        { label: 'Programação', value: 'PROGRAMACAO', checked: false },
        { label: 'Em Planejamento', value: 'EM_PLANEJAMENTO', checked: false },
        { label: 'Expedição', value: 'EXPEDICAO', checked: false },
        { label: 'Liberada para Transporte', value: 'LIBERADA_PARA_TRANSPORTE', checked: false },
        { label: 'Em Trânsito', value: 'EM_TRANSITO', checked: false },
        { label: 'Entregue', value: 'ENTREGUE', checked: false },
        { label: 'Descarregamento', value: 'DESCARREGAMENTO', checked: false },
        { label: 'Equipamento Liberado', value: 'EQUIPAMENTO_LIBERADO', checked: false },
        { label: 'Todas', value: 'TODAS', checked: true },
    ]

    tableHeader = {
        grupo: grupos[1].label,
        status: 'Todas'
    }


    constructor(props) {
        super(props)

        this.state = {
            drivers: { options: [], loading: false },
            alert: { msg: 'Preecha os filtros para começar', type: '' },
            // alert: { msg: '', type: '' },
            loading: false,
            table: [],
            tableHeader: {
                origem: '',
                destino: ''
            },
            listPedidosVisible: false,
            listPedidos: [],
            filter: {
                dataInicio: "",
                dataFim: "",
                origem: "",
                destino: "",
                grupo: grupos[1].value,
                status: ["TODAS"],
                idDrivers: [],
            },

        }
    }

    componentDidMount = () => {
        // this.getDash(this.state.filter)
    }

    getDash = data => {
        console.log(data)
        this.setState({ loading: true, table: [], alert: {}, });
        axios.post(`${url}/v1/telemetria/controleCarga/report/gerencial/${this.props.token}`, data)
            .then(d => {
                if (d.data.length) {
                    this.setState({ table: d.data, loading: false, tableHeader: { ...this.tableHeader, origem: this.state.filter.origem, destino: this.state.filter.destino } })
                } else {
                    this.setState({ alert: { msg: "Não foi possivel localizar resultados para o período selecionado.", type: '' }, loading: false })
                }
                console.log(d.data)
            }).catch(e => {
                console.log(e.response)
                var errorMsg = e.response.data.errorMessage
                this.setState({ loading: false })
                errorMsg.forEach(d => {
                    if (d === "Sessão expirada!") this.props.validateToken(this.props.token)
                    else store.addNotification({ ...this.props.bodyNotify, title: d, type: 'danger' });
                })
            })
    };

    onChangeRadio = (e) => {
        this.tableHeader.status = e.label
        this.setState({ filter: { ...this.state.filter, status: [e.value] } })
        console.log(e)
    }




    renderToolbar = () => {
        return (
            <ToolBar zero={true}>
                <div>
                    <label htmlFor="start-date" className='toolbar-label'>Inicio</label>
                    <input
                        id='start-date'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, dataInicio: i.target.value } })}
                        disabled={this.state.loading}
                        placeholder='Inicio'
                        max={getFDate()}
                        value={this.state.filter.dataInicio} />
                </div>

                <div>

                    <label htmlFor="end-period" className='toolbar-label'>Fim</label>
                    <input
                        id='end-period'
                        type="date"
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, dataFim: i.target.value } })}
                        disabled={this.state.loading || !this.state.filter.dataInicio}
                        min={this.state.filter.dataInicio}
                        value={this.state.filter.dataFim}
                    />
                </div>
                <div>
                    <label htmlFor="origem" className='toolbar-label'>Origem</label>
                    <input
                        id='origem'
                        placeholder="Origem"
                        maxLength={3}
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, origem: i.target.value } })}
                        disabled={this.state.loading}
                        value={this.state.filter.orgiem}
                    />
                </div>
                <div>
                    <label htmlFor="destino" className='toolbar-label'>Destino</label>
                    <input
                        id='destino'
                        placeholder="Destino"
                        maxLength={3}
                        className='form-control toolbar-date'
                        onChange={(i) => this.setState({ filter: { ...this.state.filter, destino: i.target.value } })}
                        disabled={this.state.loading}
                        value={this.state.filter.destino}
                    />
                </div>

                <div>
                    <label htmlFor="drivers" className='toolbar-label'>Motoristas</label>
                    {/* Select Motoristas */}
                    <Select
                        inputId='drivers'
                        isLoading={this.state.drivers.loading}
                        className='toolbar-select'
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Motoristas"
                        noOptionsMessage={e => { return !e.inputValue ? 'Pesquise os motoristas!' : `"${e.inputValue}" não foi encontrado!` }}
                        options={this.state.drivers.options}
                        isMulti
                        closeMenuOnSelect={false}
                        onChange={(i) => {
                            if (!i.length) {
                                this.setState({ filter: { ...this.state.filter, idDrivers: [] } })
                            }
                            else {
                                let idDrivers = []
                                i.forEach(d => idDrivers.push(d.value))
                                this.setState({ filter: { ...this.state.filter, idDrivers } })
                            }
                        }}
                        onInputChange={(i) => {
                            if (i.length > 2) {
                                this.setState({ drivers: { ...this.state.drivers, loading: true } });
                                axios
                                    .get(`${url}/v1/telemetria/admin/cache/drivers/${encodeURI(i)}/${this.props.token}`)
                                    .then(d => {
                                        let options = [];
                                        d.data.forEach(d => options.push({ label: d.driverName, value: d.driverId }))
                                        this.setState({ drivers: { options, loading: false } });
                                    })
                                    .catch(e => console.log(e.response));
                            }
                        }}
                        isDisabled={this.state.loading}
                    />
                </div>

                <div>
                    <label htmlFor="groups" className='toolbar-label'>Grupo</label>
                    {/* Select Grupos */}
                    <Select
                        // isDisabled={this.state.loading}
                        // isLoading={this.state.collab.loading}
                        inputId='groups'
                        className='toolbar-select'
                        loadingMessage={i => `Procurando: ${i.inputValue}`}
                        placeholder="Grupo"
                        noOptionsMessage={e => { return `"${e.inputValue}" não foi encontrado!` }}
                        options={grupos}
                        closeMenuOnSelect={true}
                        defaultValue={grupos[1]}
                        onChange={(i) => {
                            console.log(i)
                            this.setState({ filter: { ...this.state.filter, grupo: i.value } })
                        }}
                        isDisabled={this.state.loading} />
                    <div className="toolbar-space" />
                </div>
                <input
                    type="button"
                    value='Filtrar'
                    className='telemetry-button toolbar-button toolbar-button-space'
                    onClick={() => this.getDash(this.state.filter)}
                    disabled={!this.state.filter.dataInicio || !this.state.filter.dataFim || this.state.filter.grupo < 1 || this.state.loading}
                />

            </ToolBar>
        )
    }


    render() {
        return (
            <div>
                {this.renderToolbar()}
                <div className="modal-pedidos">
                    <ListOrders
                        data={this.state.listPedidos}
                        visible={this.state.listPedidosVisible}
                        _close={() => this.setState({ listPedidos: [], listPedidosVisible: false })} />
                </div>

                <RadioOptions list={this.radios} disabled={false} _function={this.onChangeRadio} />

                {this.state.loading ? (
                    <div className='app-tool-center-loading '>
                        <Loading />
                    </div>
                ) : this.state.table.length ? (
                    <div style={{ marginRight: '5px' }}>
                        <div style={{ display: 'flex', margin: '20px 0', flexWrap: 'wrap' }}>

                            {this.state.tableHeader.origem ? (
                                <spam style={{ margin: '0 20px', fontWeight: 'bold', fontSize: 17, color: 'red' }}>{`ORIGEM: ${this.state.tableHeader.origem}`}</spam>
                            ) : null}

                            {this.state.tableHeader.destino ? (
                                <spam style={{ margin: '0 20px', fontWeight: 'bold', fontSize: 17, color: 'deepskyblue' }}>{`DESTINO: ${this.state.tableHeader.destino}`}</spam>
                            ) : null}

                            <spam style={{ margin: '0 20px', fontWeight: 'bold', fontSize: 17, color: 'darkorange' }}>{this.state.tableHeader.grupo.toUpperCase()}</spam>
                            <spam style={{ margin: '0 20px', fontWeight: 'bold', fontSize: 17, color: 'RoyalBlue' }}>{this.state.tableHeader.status.toUpperCase()}</spam>
                        </div>

                        <Table responsive className="table-change-color standard-table">
                            <thead>
                                <tr>
                                <th style={{minWidth: '100px', }}>Origem</th>
                                <th style={{minWidth: '100px', }}>Destino</th>


                                    {this.columns.map((d, i) => {
                                        return (
                                            <th key={i} style={{minWidth: '100px'}}>{d}</th>
                                        )
                                    })}
                                </tr>
                            </thead>
                            <tbody style={{maxHeight: '65vh'}}>
                                {this.state.table.map((d, i) => {
                                    return (
                                        <tr key={i} className='tr-table-change-color tr-magnament-panel'>
                                            <td style={{minWidth: '100px', }}>{d.siglaOrigem}</td>
                                            <td style={{minWidth: '100px', }}>{d.siglaDestino}</td>
                                            <td style={{minWidth: '100px'}}>{d.cavalo}</td>
                                            <td style={{minWidth: '100px'}}>{d.carreta} {d.bitrem.length ? ` / ${d.bitrem}` : null} </td>
                                            <td style={{minWidth: '100px'}}>{d.nomeMotorista}</td>
                                            <td style={{minWidth: '100px'}}>{d.numCarga}</td>
                                            <td style={{minWidth: '100px'}}>{d.dataPlanejada}</td>
                                            <td style={{minWidth: '100px'}}>{d.horaSaida}</td>
                                            <td style={{minWidth: '100px'}}>{d.prevDataHoraChegada}</td>
                                            <td style={{minWidth: '100px'}}>{d.dataHoraChegada}</td>
                                            <td style={{ backgroundColor: d.atrasado ? 'red' : 'green', color: '#fff', minWidth: '100px' }}>{d.status}</td>
                                            <td style={{minWidth: '100px'}}>

                                                <Button
                                                    type="button"
                                                    className="a-b-pass list-pedidos-button"
                                                    onClick={() => this.setState({ listPedidos: d.pedidos, listPedidosVisible: true })}
                                                    disabled={!d.pedidos.length}
                                                />
                                            </td>
                                        </tr>
                                    )


                                })}

                            </tbody>
                        </Table>

                    </div>
                ) : null}
                <div style={{ width: '440px', marginTop: '20px', alignSelf: 'center' }}>
                    <ModernAlert msg={this.state.alert.msg} color={this.state.alert.type} />
                </div>
            </div>
        )
    }

}

export default ManagementPanel